import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { HolidaysWithBranchesDto } from '../../commonTypes/organization.types';
import { restoreAll } from '../restoreAll';
import { RootState } from '..';

export interface HolidayState {
    value: HolidaysWithBranchesDto[];
}

const initialState: HolidayState = {
    value: [],
};

export const holidaySlice = createSlice({
    name: 'holidays',
    initialState,
    extraReducers: builder => builder.addCase(restoreAll, () => initialState),
    reducers: {
        setHolidays: (state, action) => {
            state.value = action.payload;
        },
        mergeHolidays: (state, action: PayloadAction<HolidaysWithBranchesDto[]>) => {
            const existingIds = new Set(state.value.map(h => h.id));
            const newHolidays = action.payload.filter(h => !existingIds.has(h.id));
            state.value = [...state.value, ...newHolidays];
        },
        addHolidays: (state, action) => {
            state.value.push(action.payload);
        },
        deleteHoliday: (state, action: PayloadAction<string>) => {
            state.value = state.value.filter(holiday => holiday.id !== action.payload);
        },
    },
});

export const { setHolidays, mergeHolidays, addHolidays, deleteHoliday } = holidaySlice.actions;

export const selectHolidays = (state: RootState) => state.holidays.value;

export default holidaySlice.reducer;
